import { inject, injectable } from 'inversify'
import { Types } from '@core/ioc/types'
import type { AppLifecycle } from '@core/interfaces/app-lifecycle'
import { ServiceWorkerGateway } from '@core/services/service-worker.gateway'
import { APP_VERSION } from '@core/version'

/**
 * Registers the service worker once at boot, for every user, so the app shell
 * loads offline. Distinct from PushRepository, which registers the *same*
 * worker only when the user enables push in Settings.
 *
 * It never touches `permission()` / `requestPermission()` / `subscribe()` —
 * registering a worker does not prompt for anything, and keeping this class
 * free of those calls is what stops "offline shell at boot" from resurrecting
 * the notification-prompt-on-boot that PushRepository deliberately avoids.
 */
@injectable()
export class OfflineShellRepository implements AppLifecycle {
  private readonly serviceWorker: ServiceWorkerGateway
  private registrationStarted = false

  constructor(@inject(Types.IServiceWorkerGateway) serviceWorker: ServiceWorkerGateway) {
    this.serviceWorker = serviceWorker
  }

  initialize(): void {
    if (this.registrationStarted) return
    this.registrationStarted = true
    void this.serviceWorker.ensureRegistered(APP_VERSION)
  }
}
